import { render, staticRenderFns } from "./StudyCopy.vue?vue&type=template&id=1e06aa72"
import script from "./StudyCopy.vue?vue&type=script&lang=js"
export * from "./StudyCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports